export const environmentSystem = {
  version: 'v1.2.3'
};
